const NOTIFICATIONS_RESOURCES = {
  DEMANDS: 'DEMANDS',
};

export { NOTIFICATIONS_RESOURCES };
